export const setCookie = (cname, cvalue, expiry = null) => {
  if (expiry) {
    document.cookie = ` ${cname}=${cvalue};max-age=${expiry};path=/;secure=true;`
  } else {
    document.cookie = ` ${cname}=${cvalue};path=/;secure=true;`
  }
}

function getParsedCookies() {
  const splitCookieString = decodeURIComponent(document.cookie).split(';')
  const cookieObject = {}
  splitCookieString.forEach((cookie) => {
    const splitCookie = cookie.split('=')
    const [key, value] = splitCookie
    cookieObject[key.charAt(0) === ' ' ? key.slice(1) : key] = value
  })
  return cookieObject
}

export const getCookie = (cname) => {
  const cookies = getParsedCookies()
  return cookies[cname] || null
}
